/**
 * Formats a date string or Date object to a human-readable execution time format
 * @param date - Date string or Date object to format
 * @returns Formatted date string (e.g., "Aug 4 2025, 4:14:57")
 */
export function formatExecutionTime(date: string | Date): string {
  const dateObj = new Date(date);
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ] as const;
  const month = monthNames[dateObj.getMonth()];
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  const hours = dateObj.getHours();
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');
  const seconds = String(dateObj.getSeconds()).padStart(2, '0');
  const time = `${hours}:${minutes}:${seconds}`;
  return `${month} ${day} ${year}, ${time}`;
}
